<template>
  <div>
    <el-form :inline="true" :model="searchForm">
      <el-form-item label="店铺名称：">
        <el-input  v-model.trim="searchForm.name" @keyup.enter.native="getOldToNewListHandler"  clearable  ></el-input>
      </el-form-item>
      <el-form-item label="店铺类型：">
        <el-select v-model="searchForm.storeType" clearable>
          <el-option v-for="(item, index) in storeTypeList" :key="index" :label="item.label" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="店铺活动：">
        <el-select v-model="searchForm.moveIds" clearable multiple>
          <el-option v-for="(item, index) in moveIdsList" :key="index" :label="item.moveName" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="btnArea">
        <el-button type="primary" @click="getOldToNewListHandler">搜索查询</el-button>
        <el-button type="success" @click="addStore()">新增</el-button >
      </el-form-item>
    </el-form>

    <el-table :data="tbpg.tableData" border>
      <el-table-column prop="name" label="店铺名称" width="160"></el-table-column>
      <el-table-column prop="storeTypeName" label="店铺类型" width="160"></el-table-column>
      <el-table-column prop="moveNames" label="店铺活动" >
        <template slot-scope="scope">
            <template v-for="(item) in scope.row.moveNames">
                {{item.moveName}}
            </template> 
        </template> 
      </el-table-column>
      <el-table-column prop="longitude" label="店铺经度"></el-table-column>
      <el-table-column prop="latitude" label="店铺纬度"></el-table-column>
      <el-table-column prop="storeStateName" label="店铺状态" ></el-table-column>
      <el-table-column prop="addressInfo" label="店铺地址" ></el-table-column>
      <el-table-column  prop="openTime" label="店铺开店时间"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
            <el-button type="text" size="small" @click.native="dataEdit(scope.row)">编辑</el-button>
        </template> 
    </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="tbpg.currentPage"
      :page-sizes="[15, 50, 100, 500]"
      :page-size="tbpg.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="tbpg.total"
    >
    </el-pagination>
    <el-dialog
      :append-to-body="true"
      :title="title"
      :visible.sync="toNewCardVisible"
      width="800px"
      :close-on-click-modal="false"
    >
      <el-form ref="toNewCardForm" :rules="rules" :model="toNewCardForm" label-width="120px">
          <el-row :gutter="10">
              <el-col :span="12">
                <el-form-item label="店铺名称：" prop="name">
                <el-input v-model="toNewCardForm.name" placeholder="请输入店铺明名称" @input="change($event)"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="店铺类型：" prop="storeType">
                    <el-select v-model="toNewCardForm.storeType" clearable @input="change($event)">
                        <el-option v-for="(item, index) in storeTypeList" :key="index" :label="item.label" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="代理商名称：" prop="nickName">
                    <el-input v-model="toNewCardForm.nickName" placeholder="请输入代理商名称" @input="change($event)"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="代理商手机号：" prop="phones">
                    <el-input v-model="toNewCardForm.phones" placeholder="请输入代理商手机号" type="number" maxlength="11" @input="change($event)"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="店铺活动：" prop="moveIds">
                    <el-select v-model="toNewCardForm.moveIds" clearable multiple  @input="change($event)">
                     <el-option v-for="(item, index) in moveIdsList" :key="index" :label="item.moveName" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="店铺状态：" prop="storeState">
                    <el-select v-model="toNewCardForm.storeState" clearable>
                        <el-option v-for="(item, index) in storeStateList" :key="index" :label="item.label" :value="item.id" @input="change($event)"></el-option>
                    </el-select>
                </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="店铺经度：" prop="longitude">
                        <el-input v-model="toNewCardForm.longitude" placeholder="请输入店铺经度,如：120.6666" type="number" @input="change($event)"></el-input>
                         <el-link type="primary"  target="_blank" href="https://lbs.qq.com/getPoint/">经纬度查询</el-link>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="店铺纬度：" prop="latitude">
                        <el-input v-model="toNewCardForm.latitude" placeholder="请输入店铺纬度,如：30.6666" type="number" @input="change($event)"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="开业时间：" prop="openTime">
                        <el-input v-model="toNewCardForm.openTime" placeholder="请输入开业时间" type="text" @input="change($event)"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="省市区：" prop="addressId">
                        <el-cascader size="large" :options="options" v-model="toNewCardForm.addressId" @change="addressChange" @input="change($event)" style="width:100%;"> </el-cascader>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="店铺详细地址" prop="addressInfo">
                          <el-input v-model="toNewCardForm.addressInfo" placeholder="请输入店铺详细地址" @input="change($event)"></el-input>
                    </el-form-item>
                </el-col>
          </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="sureToNewCardHandler" >确 定</el-button  >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {getSmokeSearchList,getSmokeList,getSmokeInsert,getSmokeUpdate} from "@/api/contract.js";
import { regionData,CodeToText } from 'element-china-area-data'
import common from "@/utils/common.js";
export default {
  data() {
    const validatorPhone = (rule, value, callback) => {
      if (!(/^1[3456789]\d{9}$/.test(value))) {
        callback(new Error('代理商手机号有误，请重新输入。'))
      } else {
        callback()
      }
    }
    return {
        searchForm: {
            name: "",
            storeType: "",
            // moveIds: [],
        },
        storeTypeList:[{label:'授权店',id:'0'},{label:'专卖店',id:'1'}],
        moveIdsList:[],
        storeStateList:[{label:'启用',id:'0'},{label:'禁用',id:'1'}], 
        options: regionData,
        title:'',
        tbpg: {
            tableData: [],
            currentPage: 1,
            pageSize: 15,
            total: 0,
        },
        rules:{
            name: [
                { required: true, message: '店铺名称不能为空', trigger:['blur', 'change'] }
            ],
            storeType: [
                { required: true, message: '店铺类型不能为空', trigger: ['blur', 'change'] }
            ],
            nickName: [
                { required: true, message: '代理商名称不能为空', trigger:['blur', 'change'] }
            ],
            phones: [
                { required: true, message: '代理商手机号不能为空', trigger: ['blur', 'change'] },
                { validator: validatorPhone, trigger: ['blur', 'change'] }
            ],
            storeState: [
                { required: true, message: '店铺状态不能为空', trigger:['blur', 'change'] }
            ],
            longitude: [
                { required: true, message: '店铺经度不能为空', trigger:['blur', 'change'] }
            ],
            latitude: [
                { required: true, message: '店铺纬度不能为空', trigger:['blur', 'change']}
            ],
            addressId: [
                { required: true, message: '省市区不能为空', trigger:['blur', 'change']}
            ],
            addressInfo: [
                { required: true, message: '店铺详细地址不能为空', trigger: ['blur', 'change'] }
            ],
            openTime: [
                { required: true, message: '开业时间不能为空', trigger: ['blur', 'change'] }
            ]
        },
        toNewCardVisible: false, //显示新增编辑弹窗
        toNewCardForm: {
            name:'',
            storeType:'',
            nickName:'',
            phones:'',
            moveIds:[],
            storeState:'',
            longitude:'',
            latitude:'',
            address:'',
            addressInfo:''
        },
    };
  },
  created(){
    getSmokeSearchList().then(res=>{
        if (res.data.code == 200) {
           this.moveIdsList = res.data.data
        } else {
            this.$message.error(res.data.msg);
        }
    })
    this.getOldToNewListHandler();
  },
  methods: {
    cancel() {
        this.$refs['toNewCardForm'].resetFields();
        this.toNewCardVisible = false;
        this.$forceUpdate()
    },
    getOldToNewListHandler($event) {
      common.resetCurrentPage(this, $event, "tbpg");
      var data = common.getRequestParams(this, "tbpg", this.searchForm);
      getSmokeList(data).then((res) => {
        common.listCallback(this, res, "tbpg");
      });
    },
    addStore() {
        this.toNewCardVisible = true;
        this.toNewCardForm.id = ''
        this.title='新增店铺'
        this.$forceUpdate()
    },
    sureToNewCardHandler() {
        this.$refs['toNewCardForm'].validate((valid) => {
            if (valid) {
                this.toNewCardForm.address = this.addressTmp
                if( this.toNewCardForm.id){
                    getSmokeUpdate(this.toNewCardForm).then(res=>{
                        if(res.data.code == '200'){
                            this.cancel();
                            this.getOldToNewListHandler();
                            this.$message({ message: res.data.message, type: 'success', duration: 4000 })
                        }else{
                            this.$message({ message:res.data.message, type: 'error', duration: 4000 })
                        }
                    })
                }else{
                    getSmokeInsert(this.toNewCardForm).then(res=>{
                        if(res.data.code == '200'){
                            this.cancel();
                            this.getOldToNewListHandler();
                            this.$message({ message: res.data.message, type: 'success', duration: 4000 })
                        }else{
                              this.$message({ message: res.data.message, type: 'error', duration: 4000 })
                        }
                    })
                }
            }
         })
    },
    dataEdit(data){
        this.title='编辑店铺'
        this.toNewCardForm  = data
        this.toNewCardForm.storeState  = String(data.storeState)
        this.toNewCardForm.storeType  = String(data.storeType)
        this.toNewCardForm.moveIds=[]
        if(Array.isArray(data.moveNames) && data.moveNames.length>0){
            data.moveNames.forEach(item=>{
                this.toNewCardForm.moveIds.push(item.id)  
                this.$forceUpdate()
            })
        }
        this.toNewCardVisible = true;
    },
    handleSizeChange(val) {
      this.tbpg.pageSize = val;
      this.getOldToNewListHandler();
    },
    handleCurrentChange(val) {
      this.tbpg.currentPage = val;
      this.getOldToNewListHandler();
    },
    change(e) {
      this.$forceUpdate()
    },
    addressChange(arr) {
        if (
            arr[0] == "110000" ||
            arr[0] == "120000" ||
            arr[0] == "310000" ||
            arr[0] == "500000"
        ) {
            this.addressTmp = CodeToText[arr[0]] + CodeToText[arr[2]];
        } else {
            this.addressTmp = CodeToText[arr[0]] + CodeToText[arr[1]] + CodeToText[arr[2]];
        }
    },

  }
};
</script>

<style lang="less" scoped></style>
